import Loading from '../../../../../Components/Loading/Loading'
import knowledge from '../../../../../API/Knowledge/knowledge'
import React, { useCallback, useEffect, useState } from 'react'
import { FaRegThumbsUp, FaRegEye } from 'react-icons/fa'
import { FaCrown, FaMedal } from 'react-icons/fa6'
import { getEmployeesURL } from '../../../../../API/Employee/Employee'

const rankIcon = rank => {
	if (rank === 1) return <FaCrown className='tw-text-alert-300 tw-text-lg' />
	if (rank === 2) return <FaMedal className='tw-text-gray-400 tw-text-lg' />
	if (rank === 3) return <FaMedal className='tw-text-alert-800 tw-text-lg' />
	return null
}

export const RankingView = () => {
	const token = localStorage.getItem('token')
	const user = JSON.parse(localStorage.getItem('user'))
	const isEmployee = window.location.pathname.includes('/employee/')
	const companyId = isEmployee ? user.companyId : user.id
	const [loading, setLoading] = useState(false)
	const [rankingData, setRankingData] = useState([])
	const [rankingEmpData, setRankingEmpData] = useState([])
	const [modalOpen, setModalOpen] = useState(false)
	const [selectedColab, setSelectedColab] = useState(null)
	const [activeTab, setActiveTab] = useState('documents')
	const [employeesImages, setEmployeesImages] = useState([])

	const loadData = useCallback(async () => {
		try {
			setLoading(true)
			const [respRanking, respEmpRanking, respEmployeeImages] = await Promise.all([
				knowledge.documentRankingList(companyId),
				knowledge.empRankingList(companyId),
				getEmployeesURL(companyId, token),
			])
			const sort = respRanking.sort((a, b) => b.likesCount - a.likesCount || b.viewsCount - a.viewsCount)
			const sortEmp = respEmpRanking.sort((a, b) => b.score - a.score)
			setRankingEmpData(sortEmp)
			setRankingData(sort)
			setEmployeesImages(respEmployeeImages)
		} finally {
			setLoading(false)
		}
	}, [companyId, token])

	useEffect(() => {
		loadData()
	}, [loadData])

	const handleOpenModal = colab => {
		setSelectedColab(colab)
		setModalOpen(true)
	}

	const handleCloseModal = () => {
		setModalOpen(false)
		setSelectedColab(null)
	}

	return (
		<>
			<div className='tw-pr-10'>
				<h3 className='fw-bold tw-mb-4'>Ranking - Gestión de Conocimientos</h3>
				<div>
					Agradecemos a todos por compartir conocimientos y fortalecer nuestra cultura de colaboración. Aquí destacamos a quienes más contribuyeron.
				</div>
			</div>

			{loading ? (
				<Loading />
			) : (
				<>
					<div className='tw-flex tw-gap-2 tw-mt-8 tw-mb-2'>
						<div
							className={`tw-px-4 tw-py-2 tw-rounded-t-lg tw-cursor-pointer  ${
								activeTab === 'documents' ? 'tw-bg-white tw-shadow tw-border-b-0' : 'tw-bg-gray-100 tw-text-gray-500'
							}`}
							onClick={() => setActiveTab('documents')}
						>
							Ranking de Documentos
						</div>
						<div
							className={`tw-px-4 tw-py-2 tw-rounded-t-lg tw-cursor-pointer  ${
								activeTab === 'collaborators' ? 'tw-bg-white tw-shadow tw-border-b-0' : 'tw-bg-gray-100 tw-text-gray-500'
							}`}
							onClick={() => setActiveTab('collaborators')}
						>
							Ranking de Colaboradores
						</div>
					</div>

					<div className='tw-bg-white tw-rounded-b-xl tw-shadow tw-p-6 tw-mr-10' style={{ minHeight: 380 }}>
						{activeTab === 'documents' && (
							<>
								<div className='tw-grid tw-grid-cols-[40px_60px_2fr_1.2fr_90px_110px] tw-font-bold tw-text-gray-600 tw-py-2 tw-px-4 tw-border-b'>
									<span className='tw-text-left'>#</span>
									<span className='tw-text-left'>Rank</span>
									<span className='tw-text-left'>Documento</span>
									<span className='tw-text-left'>Autor</span>
									<span className='tw-text-left'>Me gusta</span>
									<span className='tw-text-left'>Visualizaciones</span>
								</div>
								{rankingData.map((item, idx) => (
									<div
										key={item.id}
										className={`tw-grid tw-grid-cols-[40px_60px_2fr_1.2fr_90px_110px] tw-items-center tw-py-3 tw-px-4 tw-rounded-xl ${
											idx % 2 === 0 ? 'tw-bg-gray-50' : 'tw-bg-white'
										}`}
									>
										<span className='tw-text-left tw-text-gray-400'>{idx + 1}</span>
										<span className='tw-flex tw-items-center tw-gap-2'>{rankIcon(idx + 1)}</span>
										<a href={item.url} target='_blank' rel='noopener noreferrer' download>
											{item.title}
										</a>
										<div className='div'>
											<div className='tw-flex tw-items-center tw-gap-3'>
												{item.authorName !== 'Company' && (
													<img
														src={
															employeesImages.find(img => img.mydnaUserEmail === item.authorEmail)?.url ||
															'https://assets.mydna.company/profile-placeholder.png'
														}
														alt={item.authorName}
														className='tw-w-7 tw-h-7 tw-rounded-full tw-object-cover tw-bg-gray-200'
													/>
												)}
												<span className='tw-text-left'>{item.authorName === 'Company' ? 'RRHH' : item.authorName}</span>
											</div>
										</div>

										<span className='tw-flex tw-items-center tw-gap-1 tw-text-left'>
											<FaRegThumbsUp className='tw-mr-1 tw-text-blue-500' /> {item.likesCount}
										</span>
										<span className='tw-flex tw-items-center tw-gap-1 tw-text-left'>
											<FaRegEye className='tw-mr-1' /> {item.viewsCount}
										</span>
									</div>
								))}
							</>
						)}
						{activeTab === 'collaborators' && (
							<>
								<div className='tw-grid tw-grid-cols-[40px_2fr_1fr_1fr_1fr_1fr] tw-font-bold tw-text-gray-600 tw-py-2 tw-px-4 tw-border-b'>
									<span>#</span>
									<span>Colaborador</span>
									<span>Puntuación</span>
									<span>Me gusta</span>
									<span>Visualizaciones</span>
									<span>Documentos</span>
								</div>
								{rankingEmpData.map((colab, idx) => (
									<div
										key={colab.name}
										className={`tw-grid tw-grid-cols-[40px_2fr_1fr_1fr_1fr_1fr] tw-items-center tw-py-3 tw-px-4 tw-rounded-xl ${
											idx % 2 === 0 ? 'tw-bg-gray-50' : 'tw-bg-white'
										}`}
									>
										<span className='tw-text-left tw-text-gray-400'>{idx + 1}</span>
										<div className='tw-flex tw-items-center tw-gap-3'>
											<img
												src={
													employeesImages.find(img => img.mydnaUserEmail === colab.email)?.url ||
													'https://assets.mydna.company/profile-placeholder.png'
												}
												alt={colab.authorName}
												className='tw-w-7 tw-h-7 tw-rounded-full tw-object-cover tw-bg-gray-200'
											/>
											<span className='tw-text-left'>{colab.name}</span>
										</div>
										<span className='tw-text-left'>{colab.score}</span>
										<span className='tw-flex tw-items-center tw-gap-1 tw-text-left'>
											<FaRegThumbsUp className='tw-mr-1 tw-text-blue-500' /> {colab.allLikesCount}
										</span>
										<span className='tw-flex tw-items-center tw-gap-1 tw-text-left'>
											<FaRegEye className='tw-mr-1' /> {colab.allViewsCount}
										</span>
										<span>
											<button
												className='tw-bg-purple-500 tw-text-white tw-px-3 tw-py-1 tw-rounded hover:tw-bg-purple-800 border-0'
												onClick={() => handleOpenModal(colab)}
											>
												Ver documentos
											</button>
										</span>
									</div>
								))}
							</>
						)}
					</div>

					{modalOpen && selectedColab && (
						<div className='tw-fixed tw-inset-0 tw-bg-black/40 tw-flex tw-items-center tw-justify-center tw-z-50'>
							<div className='tw-bg-white tw-rounded-lg tw-shadow-lg tw-p-6 tw-w-full tw-max-w-lg tw-relative'>
								<div
									className='tw-absolute tw-top-3 tw-right-4 tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-600 tw-text-2xl'
									onClick={handleCloseModal}
									title='Cerrar'
								>
									X
								</div>
								<h5 className='tw-font-bold tw-mb-6 tw-text-lg tw-text-center'>Documentos de {selectedColab.name}</h5>
								<div className='tw-grid tw-grid-cols-[40px_2fr] tw-font-bold tw-text-gray-600 tw-py-2 tw-px-4 tw-border-b'>
									<span>#</span>
									<span>Título</span>
								</div>
								{selectedColab.documentList && selectedColab.documentList.length > 0 ? (
									selectedColab.documentList.map((doc, idx) => (
										<div
											key={doc.id || idx}
											className={`tw-grid tw-grid-cols-[40px_2fr] tw-items-center tw-py-3 tw-px-4 tw-rounded-xl ${
												idx % 2 === 0 ? 'tw-bg-gray-50' : 'tw-bg-white'
											}`}
										>
											<span className='tw-text-left tw-text-gray-400'>{idx + 1}</span>
											<span className='tw-text-left'>
												<a href={doc.url} target='_blank' rel='noopener noreferrer' className='tw-text-blue-600 hover:tw-underline' download>
													{doc.title}
												</a>
											</span>
										</div>
									))
								) : (
									<div className='tw-p-6 tw-text-center tw-text-gray-500'>Ningún documento encontrado.</div>
								)}
							</div>
						</div>
					)}
				</>
			)}
		</>
	)
}

export default RankingView
